import React from 'react';
import { Link } from 'react-router-dom';

export default function HomeIntro({ title, tickerItems = [], onOpenQuiz }) {
  const quizLabel = 'SVARAÐU SPURNINGU DAGSINS';
  const ticker = Array.from({ length: 4 }, () => [...tickerItems, quizLabel]).flat();
  return (
    <>
      <section className="border-b border-border flex items-center justify-center min-h-[18vh] md:min-h-[19vh]">
        <div className="w-full max-w-[1100px] mx-auto px-6 sm:px-8 md:px-12 py-4 sm:py-5 md:py-5 text-center">
          <h1 className="font-display font-black uppercase text-primary tracking-[0.02em] leading-[0.85] text-balance" style={{ fontSize: 'clamp(2.2rem, 7vw, 5.1rem)' }}>{title}</h1>
          <div className="mt-4 sm:mt-5 flex flex-wrap justify-center gap-3">
            <Link to="/safnid" className="bg-primary text-primary-foreground px-6 sm:px-8 py-3 sm:py-3.5 font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] hover:opacity-90 transition-opacity">Skoða úrvalið</Link>
            <Link to="/seldu" className="border-2 border-primary text-primary px-6 sm:px-8 py-3 sm:py-3.5 font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] hover:bg-primary hover:text-primary-foreground transition-colors">Selja treyju</Link>
          </div>
        </div>
      </section>
      <div className="border-b border-border bg-background">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-2 md:py-3 grid grid-cols-1 md:grid-cols-3 gap-1.5 md:gap-8 text-center">
          <span className="font-mono text-[9px] md:text-[10px] uppercase tracking-[0.14em] text-primary">✓ Aðeins upprunalegar fótboltatreyjur</span>
          <Link to="/heimsokn" className="font-mono text-[9px] md:text-[10px] uppercase tracking-[0.14em] text-primary hover:opacity-60 transition-opacity">✓ Skoðaðu úrvalið inni í Classic Detail, Bíldshöfða 16</Link>
          <span className="font-mono text-[9px] md:text-[10px] uppercase tracking-[0.14em] text-primary">✓ Hægt að sækja samdægurs eða fá sent með Dropp</span>
        </div>
      </div>
      {tickerItems.length > 0 && (
        <div className="hidden md:block bg-primary text-primary-foreground overflow-hidden border-b border-primary-foreground/15">
          <div className="ticker-track flex whitespace-nowrap py-2">
            {ticker.map((item, i) => item === quizLabel ? (
              <Link key={i} to="/?open=treyjuthraut" onClick={onOpenQuiz ? (event) => { event.preventDefault(); onOpenQuiz(); } : undefined} className="font-mono text-[10px] uppercase tracking-[0.3em] mx-6 inline-flex items-center gap-6 hover:text-accent transition-colors cursor-pointer">{item}<span className="text-accent">✦</span></Link>
            ) : (
              <span key={i} className="font-mono text-[10px] uppercase tracking-[0.3em] mx-6 inline-flex items-center gap-6">{item}<span className="text-accent">✦</span></span>
            ))}
          </div>
        </div>
      )}
    </>
  );
}